import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { CopyEventModal } from "Views/Private/Admin/Events/CopyEventModal";
import { newAuthService } from "Service/Axios";
import {
  copyEventUrl,
  deleteEventUrl,
  registerForEventUrl,
} from "Constant/api";
import { paths } from "Constant/paths";
import { compareDates, formatDateWithFullMonth } from "Utils";

export const EventBox = ({ event, fetchEvent }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [copyModal, setCopyModal] = React.useState(false);

  const toggleCopyModal = () => {
    setCopyModal(!copyModal);
  };

  const handleRedirectToEvent = () => {
    navigate(`${paths.admin.events.details}/${event.eventId}`);
  };

  const handleRegisterEvent = async (
    registrationFormRequired,
    registrationForm
  ) => {
    if (registrationFormRequired) {
      navigate(`${paths.formInstruction}/${registrationForm}`);
      return;
    } else {
      try {
        const payload = {
          eventId: event.eventId,
        };
        const response = await newAuthService(
          registerForEventUrl,
          "POST",
          payload
        );
        if (response.status) {
          toast.success(
            t("common.messages.notification.success.registerEvent")
          );
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        toast.error(
          t("common.messages.notification.failed.somethingWentWrong")
        );
      }
    }
  };

  const handleCopyEvent = async (formData) => {
    try {
      const payload = {
        eventId: event.eventId,
        eventName: formData.eventName,
      };
      const response = await newAuthService(copyEventUrl, "POST", payload);
      if (response.status) {
        fetchEvent?.();
        toast.success(t("common.messages.notification.success.registerEvent"));
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(t("common.messages.notification.failed.somethingWentWrong"));
    }
  };

  const handleDeleteEvent = async () => {
    try {
      const payload = {
        eventId: event.eventId,
      };
      const response = await newAuthService(deleteEventUrl, "POST", payload);
      if (response.status) {
        fetchEvent?.();
        toast.success(t("common.messages.notification.success.deleteEvent"));
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(t("common.messages.notification.failed.somethingWentWrong"));
    }
  };

  return (
    <div className="rounded-3 bg-white h-100 border">
      <div className="position-relative">
        <div
          className="rounded-top-3 overflow-hidden position-relative pre-event-banner cursor-pointer image-ratio-4-1"
          onClick={handleRedirectToEvent}
        >
          <img
            src={
              event.banner
                ? event.banner
                : 
                "/assets/images/placeholders/event-placeholder.svg"
            }
            alt={event.eventName}
            className="w-100 h-100 d-block object-fit-cover"
          />
        </div>
        <div className="dropdown position-absolute top-3 right-1">
          <button
            className="button bg-transparent border-0 d-flex align-items-center"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="bx bx-dots-vertical-rounded bx-sm"></i>
          </button>
          <ul className="dropdown-menu dropdown-menu-end border-0 shadow-sm">
            {event.createdEventBy && compareDates(event.date, new Date()) && (
              <li>
                <button
                  type="button"
                  className="dropdown-item"
                  // onClick={() => toggleCreateForm(form)}
                >
                  {t("common.button.edit")}
                </button>
              </li>
            )}
            <li>
              <button
                type="button"
                className="dropdown-item"
                onClick={() => toggleCopyModal()}
              >
                {t("common.button.copy")}
              </button>
            </li>
            {event.createdEventBy && compareDates(event.date, new Date()) && (
              <li>
                <button
                  type="button"
                  className="dropdown-item"
                  onClick={handleDeleteEvent}
                >
                  {t("common.button.delete")}
                </button>
              </li>
            )}
          </ul>
        </div>
      </div>
      <div className="p-3">
        <div
          className="mb-3 align-items-center cursor-pointer"
          onClick={handleRedirectToEvent}
        >
          <h4 className="mb-0 text-sm font-semibold text-grey-900">
            {event.eventName}
            {event.status === "draft" && (
              <span className="badge bg-blue-100 text-blue-800 ml-2">
                {t("common.button.draft")}
              </span>
            )}
          </h4>
          <span className="py-0 text-xs font-medium text-grey-600">
            {event.type}
          </span>
        </div>
        <div className="mb-3">
          <ul className="m-0 mb-3 p-0 list-unstyled text-xs font-medium text-slate-600 d-flex flex-column row-gap-2">
            <li className="d-flex align-items-center column-gap-1 text-xxs text-black-600">
              <i className="bx bx-calendar text-sm text-black-400 align-middle"></i>{" "}
              {event.date && formatDateWithFullMonth(event.date)} |{" "}
              {event.duration}
            </li>
          </ul>
        </div>

        <div className="d-flex align-items-center justify-content-space-between gap-1 mt-auto pt-3 border-top">
          {event.status === "draft" ? (
            <button className="btn btn-primary" onClick={handleRedirectToEvent}>
              {t("common.button.publish")}
            </button>
          ) : (
            <>
              {event.inviteLink?.trim() && (
                <a href={event.inviteLink} className="btn btn-outline-primary">
                  Join Now
                </a>
              )}
              {event.registerEventShow && (
                <button
                  className="btn btn-primary"
                  onClick={() =>
                    handleRegisterEvent(
                      event.registrationFormRequired,
                      event.registrationForm
                    )
                  }
                >
                  Register Event
                </button>
              )}
            </>
          )}
        </div>
      </div>

      {copyModal && (
        <CopyEventModal
          show={copyModal}
          toggle={toggleCopyModal}
          data={event}
          onSubmit={handleCopyEvent}
        />
      )}
    </div>
  );
};
